import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HtmlAsText from './createmode/HtmlAsText';

const InnerHeader = ({ book, value, lastBookId,visibleElements }) => {
  // const {book} = useSelector((state) => state.entities);
  // const { book } = useSelector((state) => state.entities);
  const { reader } = useSelector((state) => state.ui.reader);
  const { loaders } = useSelector((state) => state.ui);
  const { chapter, section } = reader;

  const currentChapter = book.chapters[chapter];

  return (
    <div className='inner_header'>
      <div className='row align-items-center space-between'>
        <div className='col-lg-12'>
          <div className='content_wrap'>
            {loaders.bookLoader && value ? (
              <>
                <div className='content-skeleton mb-0 inner-head-load'></div>
                <div className='content-skeleton mb-0 inner-head-load' style={{ width: '19.6%' }}></div>
              </>
            ) : lastBookId ? (
              <>
                <h5>
                  {book.title}: <HtmlAsText htmlContent={currentChapter.title.slice(0, 7) + '...|'} />
                  <span>{book?.author}</span>
                </h5>
                <h5>
                  CHAPTER {visibleElements?.parentOrder||1}, SECTION {visibleElements?.childOrder||1}
                </h5>
              </>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default InnerHeader;
